import React from 'react';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import styled from 'styled-components';

const CellWrapper = styled.div`
  width: 100%;
  .Polaris-Link {
    width: 100%;
  }
  .name {
    color: rgba(0, 0, 0, 0.85);
    font-size: 16px;
    line-height: 16px;
  }
  .tag {
    color: rgba(0, 0, 0, 0.4);
    font-size: 12px;
    line-height: 12px;
  }
`;

const TotalTimeCell = (props) => {
  const { cell } = props;
  const totalTime = Math.floor(parseFloat(cell.value));

  return totalTime ? (
    <CellWrapper className="fx g5">
      <div className="ellipsis" title={totalTime}>
        {totalTime}h
      </div>
    </CellWrapper>
  ) : (
    <DisabledTag>NA</DisabledTag>
  );
};

export default TotalTimeCell;
